/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import { IGatsbyImageData } from 'gatsby-plugin-image'
import HeaderMedia from './headerMedia'
import { Teaser as TeaserUI, Button, Info } from '../ui'
import {
  withFormatContractType,
  withFormatSalary,
  withFormatStartDate,
} from './withFormat'
import { PayRange } from './offer/type'
import ButtonColor from '../ui/buttonColor'
import { composeOfferTitle } from '../../Utils/offers/title'

export type TeaserProps = {
  city?: string
  companyName: string
  contractType?: string
  headerImage?: string | IGatsbyImageData | null
  logo?: string | null
  salary?: PayRange
  startDate: Date | string
  title: string
  url: string
  color?: string | null
  slug: string
  jobType?: string
}

const Teaser: React.FC<TeaserProps> = ({
  city,
  companyName,
  contractType,
  headerImage,
  logo = '../../../Logo_V_Lamacompta.jpg',
  salary = {},
  startDate,
  title,
  url,
  color,
  slug,
  jobType,
}) => {
  const ContractType = withFormatContractType(Info)
  const StartDate = withFormatStartDate(Info)
  const Salary = withFormatSalary(Info)
  const logoUrl = logo || '../../../Logo_V_Lamacompta.jpg'
  const headerUrl = headerImage

  return (
    <TeaserUI
      header={<HeaderMedia url={headerUrl} companyName={companyName} colorCareerSite={color || undefined} />}
      logo={
        <img
          src={logoUrl}
          alt={`logo ${companyName}`}
          className="object-contain w-full h-full"
        />
      }
      url={url}
      type="offer"
    >
      <div className="flex flex-row items-center">
        <div className="text-lg font-medium text-night grow">{companyName}</div>
        <div className="hidden lg:block">
          {color ? (
            <ButtonColor label="Voir l'offre" invert color={color} apply />
          ) : (
            <Button label="Voir l'offre" invert color="primary" />
          )}
        </div>
      </div>
      <div
        className="text-lg font-semibold md:text-xl grow text-primary"
        style={{ color }}
      >
        {composeOfferTitle(title)}
      </div>
      <div className="flex flex-row flex-wrap gap-4">
        <ContractType contract={contractType} icon="stopwatchV2" />
        <Info value={city} icon="pin" />
        <StartDate startDate={startDate} icon="calendarV2" />
        <Salary salary={salary} icon="salaryV2" />
      </div>
    </TeaserUI>
  )
}

export default Teaser
